/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "sensors";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface GpsQualityPb {
}

export enum GpsQualityPb_Enum {
  UNKNOWN = 0,
  UNRELIABLE = 1,
  ORIGIN = 2,
  ACTIVE = 3,
  INIT = 4,
  HEALTHY = 5,
  UNRECOGNIZED = -1,
}

export function gpsQualityPb_EnumFromJSON(object: any): GpsQualityPb_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return GpsQualityPb_Enum.UNKNOWN;
    case 1:
    case "UNRELIABLE":
      return GpsQualityPb_Enum.UNRELIABLE;
    case 2:
    case "ORIGIN":
      return GpsQualityPb_Enum.ORIGIN;
    case 3:
    case "ACTIVE":
      return GpsQualityPb_Enum.ACTIVE;
    case 4:
    case "INIT":
      return GpsQualityPb_Enum.INIT;
    case 5:
    case "HEALTHY":
      return GpsQualityPb_Enum.HEALTHY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GpsQualityPb_Enum.UNRECOGNIZED;
  }
}

export function gpsQualityPb_EnumToJSON(object: GpsQualityPb_Enum): string {
  switch (object) {
    case GpsQualityPb_Enum.UNKNOWN:
      return "UNKNOWN";
    case GpsQualityPb_Enum.UNRELIABLE:
      return "UNRELIABLE";
    case GpsQualityPb_Enum.ORIGIN:
      return "ORIGIN";
    case GpsQualityPb_Enum.ACTIVE:
      return "ACTIVE";
    case GpsQualityPb_Enum.INIT:
      return "INIT";
    case GpsQualityPb_Enum.HEALTHY:
      return "HEALTHY";
    case GpsQualityPb_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseGpsQualityPb(): GpsQualityPb {
  return {};
}

export const GpsQualityPb = {
  encode(_: GpsQualityPb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GpsQualityPb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGpsQualityPb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GpsQualityPb {
    return {};
  },

  toJSON(_: GpsQualityPb): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GpsQualityPb>, I>>(base?: I): GpsQualityPb {
    return GpsQualityPb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GpsQualityPb>, I>>(_: I): GpsQualityPb {
    const message = createBaseGpsQualityPb();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
